import { Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { appConfig } from '../../brands/_current/config/app-config'

@Injectable({
  providedIn: 'root',
})
export class CookieEnabledGuard {
  constructor(private readonly router: Router) {}
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return !navigator.cookieEnabled
      ? this.router.createUrlTree(['/', appConfig.feedback.paths._root, appConfig.feedback.paths.noCookies], {
          queryParamsHandling: 'merge',
        })
      : true
  }

  canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate()
  }
}
